// Anime.tsx

import React from 'react';
import './Anime.css'; // Make sure to rename your CSS file as well
import jujutsuKaisen from '../images/jujutsu_kaisen.webp';
import onePiece from '../images/one_piece.webp';
import baki from '../images/baki.jpg';
import blackClover from '../images/black_clover.jpg';
import classroomOfTheElite from '../images/classroom_of_the_elite.jpg';
import soloLeveling from '../images/solo_leveling.jpg';

const animes = [
  {
    title: "Jujutsu Kaisen",
    creator: "Gege Akutami",
    imgSrc: jujutsuKaisen,
    description: "A high schooler joins a secret society of Sorcerers to fight against cursed spirits.",
  },
  {
    title: "One Piece",
    creator: "Eiichiro Oda",
    imgSrc: onePiece,
    description: "The grand adventure of Monkey D. Luffy and his crew to find the ultimate treasure.",
  },
  {
    title: "Baki",
    creator: "Keisuke Itagaki",
    imgSrc: baki,
    description: "An intense series about Baki Hanma's quest to become the strongest fighter in the world.",
  },
  {
    title: "Black Clover",
    creator: "Yūki Tabata",
    imgSrc: blackClover,
    description: "Asta, a boy born without magic, aims to become the Wizard King in a magical world.",
  },
  {
    title: "Classroom of the Elite",
    creator: "Shōgo Kinugasa",
    imgSrc: classroomOfTheElite,
    description: "Students navigate a cutthroat high school where only the elite can succeed.",
  },
  {
    title: "Solo Leveling",
    creator: "Chugong",
    imgSrc: soloLeveling,
    description: "The weakest hunter of all mankind gains a unique power to level up and become the strongest.",
  },
];

const Anime: React.FC = () => {
  return (
    <div className="anime-container">
      <h2 className="anime-section-title">🔥 Animes That Fuel My Hype</h2>
      <p className="anime-intro">These series have captivated me with their stories, characters, and epic battles.</p>
      <div className="animes-grid">
        {animes.map((anime, index) => (
          <div key={index} className="anime-card" style={{ '--delay': `${index * 0.1}s` } as React.CSSProperties}>
            <img src={anime.imgSrc} alt={anime.title} className="anime-cover" />
            <div className="anime-info">
              <h3 className="anime-title">{anime.title}</h3>
              <h4 className="anime-creator">{anime.creator}</h4>
              <p className="anime-description">{anime.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Anime;